import { FC, SVGProps } from 'react';

export const Products2Icon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...props}>
    <rect x="1.65" y="1.65" width="13.7" height="13.7" rx="2.35" stroke="#91979F" strokeWidth="1.3" />
    <path d="M5.15723 8.89453H9.49933" stroke="#91979F" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.15723 12.0527H11.8678" stroke="#91979F" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
